/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `processing` - processing
 * * `valid` - valid
 * * `invalid` - invalid
 * @export
 */
export const EventStateEnum = {
  PROCESSING: "processing",
  VALID: "valid",
  INVALID: "invalid",
} as const;
export type EventStateEnum = (typeof EventStateEnum)[keyof typeof EventStateEnum];

export function instanceOfEventStateEnum(value: any): boolean {
  for (const key in EventStateEnum) {
    if (Object.prototype.hasOwnProperty.call(EventStateEnum, key)) {
      if (EventStateEnum[key as keyof typeof EventStateEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EventStateEnumFromJSON(json: any): EventStateEnum {
  return EventStateEnumFromJSONTyped(json, false);
}

export function EventStateEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EventStateEnum {
  return json as EventStateEnum;
}

export function EventStateEnumToJSON(value?: EventStateEnum | null): any {
  return value as any;
}

export function EventStateEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): EventStateEnum {
  return value as EventStateEnum;
}
